import React, { Fragment, useState, useEffect, useRef } from "react";
import { Bell } from "react-feather";
import { LI, P, UL } from "../../../AbstractElements";
import { onMessage ,getMessaging} from "firebase/messaging";
import { toast } from "react-toastify";
import { messaging } from "../../../firebase";

const Notifications = () => {
  const [notifications, setNotifications] = useState([]);
  const lastIds = useRef(new Set());
console.log('messaging', messaging)
  useEffect(() => {
    const initFirebase = async () => {
    

      onMessage(messaging, (payload) => { 
        console.log("Foreground message:", payload);

        const id = payload.messageId;

     toast.info(`${payload.notification?.body}`)
   
        if (lastIds.current.has(id)) return;
        lastIds.current.add(id);

        setNotifications((prev) => [
          {
            title: payload.notification?.title,
            body: payload.notification?.body,
          },
          ...prev,
        ]);
      });
    };

    initFirebase();
  }, []);

  return (
    <Fragment>
      <LI attrLI={{ className: "onhover-dropdown" }}>
        <div className="notification-box">
          <Bell />
          {notifications.length > 0 && (
            <span className="dot-animated"></span>
          )}
        </div>

        <UL attrUL={{ className: "notification-dropdown onhover-show-div" }}>
          {notifications.length === 0 ? (
            <LI>
              <P attrPara={{ className: "f-w-700 m-0" }}>
                You have 0 Notifications 
              </P>
            </LI>
          ) : (
            notifications.map((n, i) => (
              <LI key={i}>
                <P attrPara={{ className: "m-0" }}>
                  <strong>{n.title}</strong>
                  <br />
                  {n.body}
                </P>
              </LI>
            ))
          )}
        </UL>
      </LI>
    </Fragment>
  );
};

export default Notifications;

